// extracted by mini-css-extract-plugin
module.exports = {"videoBox":"video-box_videoBox_3DAMz","defaultBox":"video-box_defaultBox_BeUzr","descInfo":"video-box_descInfo_3LFMO","info":"video-box_info_vd3Zq","btn":"video-box_btn_2kR9j"};